var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReports = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_reports",
    transform: "translate(-18 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 22,
    height: 22,
    transform: "translate(18 87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "monitoring_FILL0_wght300_GRAD-25_opsz20",
    d: "M204.116-723.418V-725.7l1.39-1.39v3.676Zm3.652,0v-5.938l1.216-1.216.174.174v6.98Zm3.652,0v-5.415l1.39,1.39v4.025Zm3.652,0v-4.894l1.39-1.39v6.285Zm3.652,0v-8.547l1.39-1.39v9.937Zm-14.61-5.883v-1.968l5.214-5.22,4.174,4.174,6.611-6.606v1.968l-6.611,6.606-4.174-4.174Z",
    transform: "translate(-183.116 829.17)",
    fill: "#8d8d8d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReports, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reports.8a630e4a.svg";
export { ForwardRef as ReactComponent };